// extracted by mini-css-extract-plugin
export default {"container":"InlineSections_container__4FVEV"};